module.exports = __webpack_public_path__ + "static/media/pharmacist.97bbea6f.jpg";